<template>
  <dashboard-layout :loading="initialLoading" loading-text="正在加载个人资料">
    <div class="profile-page">
      <div class="banner">
        <div class="main">
          <div class="name-row">
            <h2>{{ profile.nickname || "未设置昵称" }}</h2>
            <span v-if="profile.vipLabel" class="vip">{{ profile.vipLabel }}</span>
          </div>
          <p class="quote">{{ profile.quote || "还没有留下个性签名。" }}</p>
          <div class="meta">
            <span>用户ID {{ profile.userId || "—" }}</span>
            <span>加入时间 {{ profile.joinDate || "—" }}</span>
            <span>最后登录 {{ profile.lastLogin || "—" }}</span>
            <span>邮箱 {{ profile.email || "—" }} <em v-if="profile.email">已验证</em></span>
          </div>
        </div>
        <div class="side">
          <el-button size="small" round @click="nameVisible = true">编辑资料</el-button>
          <div class="status">● 已登录</div>
          <div class="intimacy">
            <label>亲密度</label>
            <el-progress :percentage="profile.intimacy" color="#c94225" :show-text="false" />
            <span>{{ profile.intimacy }}/100</span>
          </div>
        </div>
      </div>

      <div class="workspace-heading">
        <div>
          <span>账户与服务</span>
          <h2>日常管理</h2>
        </div>
        <p>个人资料、套餐、邀请与绑定集中在这里。</p>
      </div>

      <div class="row2">
        <div class="card">
          <h3>个人资料</h3>
          <div class="kv"><span>昵称</span><b>{{ profile.nickname }}</b></div>
          <div class="kv"><span>年龄</span><b>{{ profile.age || "未填写" }}</b></div>
          <div class="kv"><span>性别</span><b>{{ profile.gender || "未填写" }}</b></div>
          <div class="kv"><span>生日</span><b>{{ profile.birthday || "未填写" }}</b></div>
          <div class="kv"><span>手机</span><b>{{ profile.phone || "未填写" }}</b></div>
          <div class="kv"><span>时区</span><b>{{ profile.timezone || "Asia/Shanghai" }}</b></div>
          <el-button size="small" round class="edit" @click="nameVisible = true">编辑资料</el-button>
        </div>
        <div class="card">
          <h3>套餐用量</h3>
          <div v-if="usage.subscription" class="quota-list">
            <div v-for="item in quotaItems" :key="item.key" class="quota">
              <div class="quota-head">
                <label>{{ item.label }}</label>
                <small>剩余 {{ item.remaining.toLocaleString() }}</small>
              </div>
              <el-progress :percentage="item.percent" color="#c94225" />
              <small class="quota-num">{{ item.used.toLocaleString() }} / {{ item.limit.toLocaleString() }}</small>
            </div>
            <p class="quota-cycle">统计周期 {{ usage.subscription.usage_cycle || "本月" }}</p>
          </div>
          <p v-else class="empty-tip">暂无套餐数据</p>
          <el-button type="primary" size="small" round @click="$router.push('/pricing')">前往套餐中心</el-button>
          <div v-if="orders.length" class="order-list">
            <h4>订单记录</h4>
            <div v-for="o in orders" :key="o.out_trade_no" class="order-item">
              <div>
                <b>{{ o.plan_name }}（{{ o.period === "yearly" ? "年付" : "月付" }}）</b>
                <small>{{ (o.created_at || "").slice(0, 16).replace("T", " ") }}</small>
              </div>
              <span class="o-amount">¥{{ o.amount }}</span>
              <span class="o-status" :class="o.status">{{ orderStatusLabel(o.status) }}</span>
            </div>
          </div>
        </div>
        <div class="card">
          <h3>邀请好友</h3>
          <div class="invite-code">{{ profile.inviteCode || "暂未生成" }} <el-button size="mini" round @click="copyInvite">复制</el-button></div>
          <p>{{ inviteLink }}</p>
          <el-button size="small" round @click="copyInvite">复制邀请链接</el-button>
          <img src="@/assert/clean_renamed/双爱心-渐变.png" alt="" class="invite-heart" />
        </div>
        <div class="card">
          <h3>微信账号绑定</h3>
          <p class="wx-name">已绑定 {{ wxAccounts.length }} 个微信号</p>
          <p class="wx-date">{{ wxAccounts.length ? wxAccounts.map((a) => a.nickname || a.wechat_account_id).join(" · ") : "暂未绑定微信号" }}</p>
          <el-button size="small" round @click="$router.push('/wechat-accounts')">管理绑定</el-button>
        </div>
      </div>

      <!-- 角色卡分享中心 -->
      <div class="workspace-heading">
        <div>
          <span>协作关系</span>
          <h2>分享与授权</h2>
        </div>
        <p>查看角色卡流转状态与代聊权限。</p>
      </div>

      <div class="share-center">
        <div class="card">
          <h3 class="card-head">我分享的角色卡 <a @click="$router.push('/role-cards')">去管理</a></h3>
          <div v-for="s in shares" :key="s.id" class="share-item">
            <div class="si-main">
              <b>{{ s.roleCardName }}</b>
              <p>{{ s.title }}</p>
              <small>导入 {{ s.importsCount }} 次 · 授权 {{ s.grantsCount }} 人 · {{ s.expiresAt }}</small>
            </div>
            <el-button size="mini" round @click="revokeShare(s)">撤销</el-button>
          </div>
          <p v-if="!shares.length" class="empty-tip">还没有分享过角色卡</p>
        </div>

        <div class="card">
          <h3>我导入的角色卡</h3>
          <div v-for="im in imports" :key="im.id" class="imp-item">
            <div>
              <b>{{ im.name }}</b>
              <small>来自 {{ im.fromUser }} · {{ im.importedAt }}</small>
            </div>
            <span class="imp-state" :class="{ on: im.companionCreated }">
              {{ im.companionCreated ? "已创建伴侣" : "未使用" }}
            </span>
          </div>
          <p v-if="!imports.length" class="empty-tip">还没有导入的角色卡</p>
        </div>

        <div class="card">
          <h3>我授权的代聊</h3>
          <div v-for="g in grants" :key="g.id" class="grant-item">
            <div>
              <b>{{ g.companionName }}</b>
              <small>授权给 {{ g.granteeUser }}</small>
            </div>
            <div class="grant-tags">
              <span v-if="g.canView">查看</span>
              <span v-if="g.canTakeover" class="takeover">代聊</span>
              <el-button size="mini" round class="revoke" @click="revokeGrant(g)">撤销</el-button>
            </div>
          </div>
          <p v-if="!grants.length" class="empty-tip">暂无授权</p>
        </div>
      </div>

      <div class="workspace-heading">
        <div>
          <span>账户状态</span>
          <h2>使用与安全</h2>
        </div>
        <p>掌握使用规模，并维护账户访问安全。</p>
      </div>

      <div class="row3">
        <div class="card wide usage-card">
          <h3>使用统计</h3>
          <div class="mini-stats">
            <div><b>{{ usage.companions }}</b><small>伴侣数量</small></div>
            <div><b>{{ usage.roleCards }}</b><small>角色卡数量</small></div>
            <div><b>{{ usage.requests }}</b><small>对话请求数</small></div>
            <div :title="formatFullNumber(usage.totalTokens)">
              <b>{{ formatCompactNumber(usage.totalTokens) }}</b><small>Token 用量</small>
            </div>
          </div>
        </div>
        <div class="card">
          <h3>安全设置</h3>
          <button type="button" class="sec-item" @click="nameVisible = true">
            <span>修改昵称</span><i class="el-icon-arrow-right" aria-hidden="true"></i>
          </button>
          <button type="button" class="sec-item" @click="pwdVisible = true">
            <span>修改密码</span><i class="el-icon-arrow-right" aria-hidden="true"></i>
          </button>
          <button type="button" class="sec-item" @click="findVisible = true">
            <span>找回 / 重置密码</span><i class="el-icon-arrow-right" aria-hidden="true"></i>
          </button>
          <button type="button" class="sec-item" @click="logoutAll">
            <span>退出所有设备</span><i class="el-icon-arrow-right" aria-hidden="true"></i>
          </button>
          <button type="button" class="sec-item danger" @click="deactivate">
            <span>注销账号</span><i class="el-icon-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
        <div class="card">
          <h3>最近活动</h3>
          <p class="empty-tip">最近活动暂未接入真实记录</p>
        </div>
      </div>
    </div>

    <!-- 编辑资料 / 改昵称 -->
    <el-dialog title="编辑资料" :visible.sync="nameVisible" width="420px" custom-class="yw-dialog">
      <el-form label-position="top">
        <el-form-item label="昵称"><el-input v-model="editForm.nickname" /></el-form-item>
        <el-form-item label="个性签名"><el-input type="textarea" :rows="2" v-model="editForm.quote" /></el-form-item>
        <el-form-item label="个人简介"><el-input type="textarea" :rows="3" v-model="editForm.bio" /></el-form-item>
        <div class="grid-2 form-grid">
          <el-form-item label="年龄"><el-input-number v-model="editForm.age" :min="1" :max="120" controls-position="right" style="width: 100%" /></el-form-item>
          <el-form-item label="性别">
            <el-select v-model="editForm.gender" placeholder="请选择性别" style="width: 100%">
              <el-option label="女" value="女" />
              <el-option label="男" value="男" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
          <el-form-item label="生日"><el-date-picker v-model="editForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 100%" /></el-form-item>
          <el-form-item label="手机"><el-input v-model="editForm.phone" /></el-form-item>
          <el-form-item label="时区"><el-input v-model="editForm.timezone" placeholder="Asia/Shanghai" /></el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button round @click="nameVisible = false">取消</el-button>
        <el-button type="primary" round @click="saveProfile">保存</el-button>
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="pwdVisible" width="420px" custom-class="yw-dialog">
      <el-form label-position="top">
        <el-form-item label="当前密码"><el-input type="password" show-password v-model="pwdForm.old" /></el-form-item>
        <el-form-item label="新密码"><el-input type="password" show-password v-model="pwdForm.new1" /></el-form-item>
        <el-form-item label="确认新密码"><el-input type="password" show-password v-model="pwdForm.new2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button round @click="pwdVisible = false">取消</el-button>
        <el-button type="primary" round @click="savePwd">确认修改</el-button>
      </span>
    </el-dialog>

    <!-- 找回密码 -->
    <el-dialog title="找回 / 重置密码" :visible.sync="findVisible" width="420px" custom-class="yw-dialog">
      <el-form label-position="top">
        <el-form-item label="邮箱"><el-input v-model="findEmail" placeholder="请输入注册邮箱" /></el-form-item>
        <el-form-item label="验证码">
          <div class="code-row">
            <el-input v-model="findCode" placeholder="请输入验证码" />
            <el-button round :disabled="resetCodeLeft > 0" @click="sendResetCode">{{ resetCodeText }}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="新密码"><el-input type="password" show-password v-model="findPwd" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button round @click="findVisible = false">取消</el-button>
        <el-button type="primary" round @click="doReset">重置密码</el-button>
      </span>
    </el-dialog>
  </dashboard-layout>
</template>

<script>
import { authApi, dashboardApi, paymentApi, shareApi, wechatApi, getUser, setAuth, clearAuth } from "@/services/api";
import DashboardLayout from "@/components/DashboardLayout.vue";

const CODE_COOLDOWN_SECONDS = 120;

export default {
  name: "ProfileView",
  components: { DashboardLayout },
  data() {
    const u = getUser();
    return {
      profile: {
        nickname: (u && u.display_name) || "",
        quote: (u && u.quote) || "",
        bio: (u && u.bio) || "",
        age: (u && u.age) || 0,
        gender: (u && u.gender) || "",
        birthday: (u && u.birthday) || "",
        phone: (u && u.phone) || "",
        timezone: (u && u.timezone) || "Asia/Shanghai",
        inviteCode: (u && u.invite_code) || "",
        invitedByCode: (u && u.invited_by_code) || "",
        email: (u && u.email) || "",
        userId: u ? "UID-" + u.id : "",
        joinDate: "",
        lastLogin: "",
        vipLabel: "",
        intimacy: 0,
      },
      wxAccounts: [],
      orders: [],
      shares: [],
      imports: [],
      grants: [],
      usage: { quota: 0, totalTokens: 0, requests: 0, companions: 0, roleCards: 0, subscription: null },
      nameVisible: false,
      pwdVisible: false,
      findVisible: false,
      editForm: {
        nickname: (u && u.display_name) || "",
        quote: (u && u.quote) || "",
        bio: (u && u.bio) || "",
        age: (u && u.age) || null,
        gender: (u && u.gender) || "",
        birthday: (u && u.birthday) || "",
        phone: (u && u.phone) || "",
        timezone: (u && u.timezone) || "Asia/Shanghai",
      },
      pwdForm: { old: "", new1: "", new2: "" },
      findEmail: "",
      findCode: "",
      findPwd: "",
      resetCodeLeft: 0,
      resetCodeTimer: null,
      initialLoading: true,
    };
  },
  computed: {
    quotaItems() {
      const sub = this.usage.subscription || {};
      return [
        this.makeQuotaItem("message", "消息", sub.message_used, sub.message_limit),
        this.makeQuotaItem("image", "生图", sub.image_used, sub.image_limit),
        this.makeQuotaItem("voice", "语音", sub.voice_used, sub.voice_limit),
      ];
    },
    resetCodeText() {
      return this.resetCodeLeft > 0 ? `${this.resetCodeLeft}s` : "发送验证码";
    },
    inviteLink() {
      const code = this.profile.inviteCode || "";
      return code ? `${window.location.origin}/#/login?invite=${encodeURIComponent(code)}` : "";
    },
  },
  created() {
    this.load();
    this.loadOrders();
  },
  beforeDestroy() {
    this.stopResetCodeCountdown();
  },
  methods: {
    formatCompactNumber(value) {
      const normalized = Math.max(0, Number(value) || 0);
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 2,
      }).format(normalized);
    },
    formatFullNumber(value) {
      return (Math.max(0, Number(value) || 0)).toLocaleString("zh-CN");
    },
    orderStatusLabel(status) {
      return {
        paid: "已支付",
        pending: "待支付",
        cancelling: "取消处理中",
        cancelled: "已取消",
        closed: "已关闭",
      }[status] || status || "未知";
    },
    makeQuotaItem(key, label, used, limit) {
      const normalizedUsed = Number(used) || 0;
      const normalizedLimit = Number(limit) || 0;
      return {
        key,
        label,
        used: normalizedUsed,
        limit: normalizedLimit,
        remaining: Math.max(0, normalizedLimit - normalizedUsed),
        percent: normalizedLimit > 0 ? Math.min(100, Math.round((normalizedUsed / normalizedLimit) * 100)) : 0,
      };
    },
    async loadOrders() {
      try {
        this.orders = (await paymentApi.orders()) || [];
      } catch (e) {
        this.orders = [];
      }
    },
    async load() {
      try {
        const dash = await dashboardApi.get();
        this.profile.nickname = dash.user.display_name;
        this.profile.quote = dash.user.quote || "";
        this.profile.bio = dash.user.bio || "";
        this.profile.age = dash.user.age || 0;
        this.profile.gender = dash.user.gender || "";
        this.profile.birthday = dash.user.birthday || "";
        this.profile.phone = dash.user.phone || "";
        this.profile.timezone = dash.user.timezone || "Asia/Shanghai";
        this.profile.inviteCode = dash.user.invite_code || "";
        this.profile.invitedByCode = dash.user.invited_by_code || "";
        this.profile.email = dash.user.email;
        this.profile.userId = "UID-" + dash.user.id;
        this.profile.joinDate = (dash.user.created_at || "").replace("T", " ").slice(0, 16);
        this.profile.lastLogin = (dash.user.last_login_at || dash.user.updated_at || "").replace("T", " ").slice(0, 16);
        if (dash.subscription) this.profile.vipLabel = dash.subscription.plan_name;
        const tu = dash.user.token_usage || {};
        this.usage = {
          quota: dash.user.token_quota || 0,
          totalTokens: tu.total_tokens || 0,
          requests: tu.requests_count || 0,
          companions: dash.companions_count || 0,
          roleCards: dash.role_cards_count || 0,
          subscription: dash.subscription || null,
        };
        this.editForm = {
          nickname: dash.user.display_name,
          quote: dash.user.quote || "",
          bio: dash.user.bio || "",
          age: dash.user.age || null,
          gender: dash.user.gender || "",
          birthday: dash.user.birthday || "",
          phone: dash.user.phone || "",
          timezone: dash.user.timezone || "Asia/Shanghai",
        };
      } catch (e) {
        this.$message.error(e.message || "加载个人资料失败");
      } finally {
        // 个人资料是首屏核心；分享、微信号等次要区块继续在后台加载，不阻塞页面。
        this.initialLoading = false;
      }
      try {
        const shares = await shareApi.myShares();
        this.shares = (shares || []).map((s) => ({
          id: s.id,
          roleCardName: "角色卡 #" + s.role_card_id,
          title: s.title || s.message,
          importsCount: s.import_count,
          grantsCount: s.grant_count,
          expiresAt: s.expires_at || "永久有效",
        }));
      } catch (e) {
        /* ignore */
      }
      try {
        this.wxAccounts = await wechatApi.list();
      } catch (e) {
        this.wxAccounts = [];
      }
      try {
        const imports = await shareApi.myImports();
        this.imports = (imports || []).map((im) => ({
          id: im.id,
          name: im.imported_role_card.name,
          fromUser: im.source_owner_display_name || "用户#" + im.source_owner_user_id,
          importedAt: (im.created_at || "").slice(0, 10),
          companionCreated: !!im.companion_created,
        }));
      } catch (e) {
        this.imports = [];
      }
      try {
        const grants = await shareApi.myGrants();
        this.grants = (grants || []).map((g) => ({
          id: g.id,
          companionId: g.companion_id,
          companionName: g.companion_name || "伴侣#" + g.companion_id,
          granteeUser: g.grantee_display_name || "用户#" + g.grantee_user_id,
          canView: g.can_view_messages,
          canTakeover: g.can_takeover_reply,
        }));
      } catch (e) {
        this.grants = [];
      }
    },
    async saveProfile() {
      const name = (this.editForm.nickname || "").trim();
      if (!name) {
        this.$message.warning("昵称不能为空");
        return;
      }
      const age = Number(this.editForm.age);
      if (!Number.isInteger(age) || age < 1 || age > 120) {
        this.$message.warning("请输入 1 至 120 岁之间的有效年龄");
        return;
      }
      if (!this.editForm.gender) {
        this.$message.warning("请选择性别");
        return;
      }
      try {
        const user = await authApi.updateProfile({
          display_name: name,
          quote: this.editForm.quote || "",
          bio: this.editForm.bio || "",
          age,
          gender: this.editForm.gender || "",
          birthday: this.editForm.birthday || "",
          phone: this.editForm.phone || "",
          timezone: this.editForm.timezone || "Asia/Shanghai",
        });
        setAuth(null, user);
        this.profile.nickname = user.display_name;
        this.profile.quote = user.quote || "";
        this.profile.bio = user.bio || "";
        this.profile.age = user.age || 0;
        this.profile.gender = user.gender || "";
        this.profile.birthday = user.birthday || "";
        this.profile.phone = user.phone || "";
        this.profile.timezone = user.timezone || "Asia/Shanghai";
        this.profile.inviteCode = user.invite_code || this.profile.inviteCode;
        this.nameVisible = false;
        this.$message.success("资料已更新");
      } catch (e) {
        this.$message.error(e.message || "更新失败");
      }
    },
    copyInvite() {
      const text = this.inviteLink || this.profile.inviteCode;
      if (!text) return;
      const input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.$message.success("邀请链接已复制");
    },
    async savePwd() {
      if (!this.pwdForm.old) {
        this.$message.warning("请输入当前密码");
        return;
      }
      if (!this.pwdForm.new1 || this.pwdForm.new1 !== this.pwdForm.new2) {
        this.$message.warning("两次输入的新密码不一致");
        return;
      }
      try {
        await authApi.changePassword(this.pwdForm.old, this.pwdForm.new1);
        this.pwdVisible = false;
        this.pwdForm = { old: "", new1: "", new2: "" };
        this.$message.success("密码已修改");
      } catch (e) {
        this.$message.error(e.message || "修改失败");
      }
    },
    async sendResetCode() {
      if (!this.findEmail) {
        this.$message.warning("请输入注册邮箱");
        return;
      }
      try {
        await authApi.sendResetCode(this.findEmail);
        this.startResetCodeCountdown();
        this.$message.success("验证码已发送");
      } catch (e) {
        this.$message.error(e.message || "发送失败");
      }
    },
    startResetCodeCountdown() {
      this.stopResetCodeCountdown();
      this.resetCodeLeft = CODE_COOLDOWN_SECONDS;
      this.resetCodeTimer = window.setInterval(() => {
        this.resetCodeLeft -= 1;
        if (this.resetCodeLeft <= 0) this.stopResetCodeCountdown();
      }, 1000);
    },
    stopResetCodeCountdown() {
      if (this.resetCodeTimer) {
        window.clearInterval(this.resetCodeTimer);
        this.resetCodeTimer = null;
      }
      if (this.resetCodeLeft < 0) this.resetCodeLeft = 0;
    },
    async doReset() {
      if (!this.findEmail || !this.findCode || !this.findPwd) {
        this.$message.warning("请填写邮箱、验证码和新密码");
        return;
      }
      try {
        await authApi.resetPassword({ email: this.findEmail, code: this.findCode, new_password: this.findPwd });
        this.findVisible = false;
        this.findCode = "";
        this.findPwd = "";
        this.$message.success("密码已重置，请用新密码登录");
      } catch (e) {
        this.$message.error(e.message || "重置失败");
      }
    },
    logoutAll() {
      this.$confirm("退出所有设备后，需要重新登录，确定继续吗？", "退出所有设备", { type: "warning" })
        .then(() => {
          clearAuth();
          this.$router.push("/login");
        })
        .catch(() => {});
    },
    deactivate() {
      this.$prompt("注销账号将停用你的账号并退出登录。请输入登录密码确认：", "注销账号", {
        type: "warning",
        confirmButtonText: "确定注销",
        confirmButtonClass: "el-button--danger",
        inputType: "password",
        inputPlaceholder: "登录密码",
      })
        .then(async ({ value }) => {
          try {
            await authApi.deactivate(value);
            clearAuth();
            this.$message.success("账号已注销");
            this.$router.push("/login");
          } catch (e) {
            this.$message.error(e.message || "注销失败");
          }
        })
        .catch(() => {});
    },
    revokeShare(s) {
      this.$confirm(`撤销「${s.roleCardName}」的分享链接？已导入的角色卡不受影响。`, "撤销分享", { type: "warning" })
        .then(async () => {
          try {
            await shareApi.revoke(s.id);
            this.shares = this.shares.filter((x) => x.id !== s.id);
            this.$message.success("已撤销分享");
          } catch (e) {
            this.$message.error(e.message || "撤销失败");
          }
        })
        .catch(() => {});
    },
    revokeGrant(g) {
      this.$confirm(`撤销对 ${g.granteeUser} 的代聊授权？`, "撤销授权", { type: "warning" })
        .then(async () => {
          try {
            await shareApi.revokeGrant(g.companionId, g.id);
            this.grants = this.grants.filter((x) => x.id !== g.id);
            this.$message.success("已撤销授权");
          } catch (e) {
            this.$message.error(e.message || "撤销失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.profile-page {
  .banner {
    display: flex;
    gap: 20px;
    margin-bottom: 18px;
    padding: 28px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);

    .main {
      flex: 1;

      .name-row {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        h2 {
          margin: 0;
          font-size: 24px;
        }

        .vip {
          padding: 2px 10px;
          border-radius: 10px;
          color: #d4a017;
          font-size: 11px;
          background: linear-gradient(90deg, #fff8e6, #ffecc8);
        }
      }

      .quote {
        margin: 0 0 14px;
        color: #999;
        font-size: 14px;
      }

      .meta {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;

        span {
          color: #999;
          font-size: 12px;

          em {
            margin-left: 4px;
            color: #52c41a;
            font-style: normal;
          }
        }
      }
    }

    .side {
      text-align: right;

      .status {
        margin: 12px 0;
        color: #52c41a;
        font-size: 13px;
      }

      .intimacy {
        label {
          display: block;
          margin-bottom: 6px;
          color: #999;
          font-size: 12px;
          text-align: left;
        }

        span {
          color: var(--xyo-primary);
          font-size: 12px;
        }
      }
    }
  }

  .row2 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 16px;
  }

  .row3 {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr;
    gap: 16px;
    margin: 16px 0;
  }

  .share-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;

    .card-head {
      display: flex;
      justify-content: space-between;
      align-items: center;

      a {
        color: var(--xyo-primary);
        font-size: 12px;
        cursor: pointer;
      }
    }

    .share-item,
    .imp-item,
    .grant-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid var(--xyo-line);

      b {
        font-size: 13px;
      }

      p {
        margin: 2px 0;
        color: #888;
        font-size: 12px;
      }

      small {
        color: #bbb;
        font-size: 11px;
      }
    }

    .imp-state {
      padding: 2px 10px;
      border-radius: 10px;
      color: #999;
      font-size: 11px;
      background: #f3f3f3;

      &.on {
        color: #52c41a;
        background: #f0fae8;
      }
    }

    .grant-tags {
      display: flex;
      align-items: center;
      gap: 6px;

      span {
        padding: 1px 8px;
        border-radius: 8px;
        color: var(--xyo-primary);
        font-size: 11px;
        background: var(--xyo-accent-pale);

        &.takeover {
          color: var(--xyo-warning);
          background: var(--xyo-warning-soft);
        }
      }

      .revoke {
        color: var(--xyo-danger);
        border-color: #ddb5ae;
      }
    }

    .empty-tip {
      margin: 8px 0 0;
      color: #bbb;
      font-size: 13px;
    }
  }

  .card {
    padding: 20px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.25s;

    &:hover {
      box-shadow: var(--xyo-shadow-sm);
    }

    h3 {
      margin: 0 0 16px;
      font-size: 16px;
    }

    .kv {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      font-size: 13px;

      span {
        color: #999;
      }
    }

    .edit {
      margin-top: 8px;
      color: var(--xyo-primary);
      border-color: var(--xyo-line-strong);
    }

    .quota-list {
      margin-bottom: 14px;
    }

    .quota {
      margin-bottom: 10px;

      .quota-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 6px;
      }

      label,
      .quota-head small {
        color: #999;
        font-size: 12px;
      }

      .quota-num {
        display: block;
        margin-top: 4px;
        color: #bbb;
        font-size: 11px;
      }
    }

    .quota-cycle {
      margin: 4px 0 0;
      color: #aaa;
      font-size: 12px;
    }

    .order-list {
      margin-top: 14px;
      padding-top: 10px;
      border-top: 1px dashed var(--xyo-line);

      h4 {
        margin: 0 0 8px;
        color: #333;
        font-size: 13px;
      }

      .order-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 0;

        > div {
          flex: 1;
          min-width: 0;

          b {
            display: block;
            font-size: 12px;
          }

          small {
            color: #bbb;
            font-size: 11px;
          }
        }

        .o-amount {
          color: #333;
          font-size: 13px;
          font-weight: 600;
        }

        .o-status {
          padding: 1px 8px;
          border-radius: 8px;
          font-size: 11px;
          color: #999;
          background: #f5f5f5;

          &.paid {
            color: #52c41a;
            background: #f0fbe8;
          }

          &.pending {
            color: #faad14;
            background: #fff9e8;
          }

          &.cancelling {
            color: #409eff;
            background: #ecf5ff;
          }

          &.cancelled,
          &.closed {
            color: #999;
            background: #f5f5f5;
          }
        }
      }
    }

    .invite-code {
      margin-bottom: 10px;
      padding: 10px;
      border-radius: 10px;
      color: var(--xyo-primary);
      font-size: 18px;
      font-weight: 700;
      background: var(--xyo-accent-pale);
    }

    .invite-heart {
      display: block;
      width: 36px;
      margin-left: auto;
      margin-top: 8px;
    }

    .wx-name {
      margin: 0 0 4px;
      font-weight: 600;
    }

    .wx-date {
      margin: 0 0 12px;
      color: #999;
      font-size: 12px;
    }

    .mini-stats {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      margin-bottom: 16px;

      div {
        padding: 12px;
        border-radius: 12px;
        text-align: center;
        background: #fafafa;

        b {
          display: block;
          font-size: 20px;
        }

        small {
          color: #999;
          font-size: 11px;
        }
      }
    }

    .chart {
      position: relative;
      height: 120px;
      border-radius: 12px;
      background: linear-gradient(180deg, rgba(201, 66, 37, 0.12) 0%, transparent 100%);

      .chart-decoration {
        position: absolute;
        right: 8px;
        top: 6px;
        width: 56px;
        opacity: 0.55;
      }
    }

    .sec-item,
    .act {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      color: inherit;
      background: transparent;
      font: inherit;
      text-align: left;
      appearance: none;
      border: 0;
      border-bottom: 1px solid var(--xyo-line);
      font-size: 13px;
      cursor: pointer;
      transition: color 0.2s, background-color 0.2s;

      &:hover {
        color: var(--xyo-primary);
      }

      &:focus-visible {
        border-radius: 6px;
        outline: 2px solid var(--xyo-primary);
        outline-offset: 2px;
      }

      i {
        color: #ccc;
      }

      &.danger {
        span {
          color: var(--xyo-danger);
        }
      }

      em {
        color: #52c41a;
        font-style: normal;
        font-size: 12px;
      }
    }
  }

  @media (max-width: 768px) {
    .banner {
      flex-wrap: wrap;
      gap: 12px;
      padding: 16px;
    }

    .row2 {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .row3,
    .share-center {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .mini-stats {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

.code-row {
  display: flex;
  gap: 8px;

  .el-input {
    flex: 1;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 14px;
}
</style>

<style scoped lang="scss">
/* Warm workspace refresh: identity first, then grouped operational areas. */
.profile-page {
  width: 100%;
  max-width: 1320px;
  min-width: 0;
  margin: 0 auto;
  color: var(--xyo-ink);

  .banner {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: end;
    gap: 32px;
    margin: 0 0 36px;
    padding: 8px 4px 28px;
    border-bottom: 1px solid var(--xyo-line);
    border-radius: 0;
    background: transparent;
    box-shadow: none;

    .main {
      min-width: 0;
    }

    .name-row {
      gap: 12px;
      margin-bottom: 10px;

      h2 {
        color: var(--xyo-ink-strong);
        font-size: clamp(26px, 2.2vw, 34px);
        font-weight: 720;
        letter-spacing: -0.025em;
      }

      .vip {
        padding: 4px 9px;
        border: 1px solid #e5c287;
        border-radius: 999px;
        color: var(--xyo-warning);
        background: var(--xyo-warning-soft);
        font-size: 11px;
        font-weight: 700;
      }
    }

    .quote {
      max-width: 720px;
      margin: 0 0 18px;
      color: var(--xyo-ink-soft);
      font-size: 14px;
      line-height: 1.7;
    }

    .meta {
      gap: 8px 22px;

      span {
        position: relative;
        color: var(--xyo-muted);
        font-size: 12px;
        line-height: 1.7;

        em {
          color: var(--xyo-success);
          font-weight: 700;
        }
      }
    }

    .side {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-areas:
        "action status"
        "intimacy intimacy";
      align-items: center;
      justify-items: end;
      gap: 12px 14px;
      min-width: 248px;
      text-align: left;

      > .el-button {
        grid-area: action;
      }

      .status {
        grid-area: status;
        margin: 0;
        padding: 5px 9px;
        border-radius: 999px;
        color: var(--xyo-success);
        background: var(--xyo-success-soft);
        font-size: 12px;
        font-weight: 700;
      }

      .intimacy {
        grid-area: intimacy;
        display: grid;
        grid-template-columns: auto minmax(110px, 1fr) auto;
        align-items: center;
        gap: 10px;
        width: 100%;

        label {
          margin: 0;
          color: var(--xyo-muted);
          font-size: 12px;
          white-space: nowrap;
        }

        span {
          color: var(--xyo-primary);
          font-size: 12px;
          font-variant-numeric: tabular-nums;
        }
      }
    }
  }

  .workspace-heading {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;
    margin: 0 4px 12px;

    span {
      display: block;
      margin-bottom: 4px;
      color: var(--xyo-primary);
      font-size: 11px;
      font-weight: 750;
      letter-spacing: 0.1em;
    }

    h2 {
      margin: 0;
      color: var(--xyo-ink-strong);
      font-size: 20px;
      line-height: 1.35;
    }

    p {
      max-width: 360px;
      margin: 0 0 2px;
      color: var(--xyo-muted);
      font-size: 12px;
      line-height: 1.6;
      text-align: right;
    }
  }

  .row2,
  .share-center,
  .row3 {
    gap: 0;
    overflow: hidden;
    margin: 0 0 34px;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);

    > .card {
      min-width: 0;
      padding: 24px;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
      transition: background-color 180ms ease;

      &:hover {
        background: var(--xyo-accent-pale);
        box-shadow: none;
      }
    }
  }

  .row2 {
    grid-template-columns: minmax(280px, 0.9fr) minmax(380px, 1.35fr);

    > .card:nth-child(1),
    > .card:nth-child(2) {
      border-bottom: 1px solid var(--xyo-line);
    }

    > .card:nth-child(odd) {
      border-right: 1px solid var(--xyo-line);
    }
  }

  .share-center {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    > .card:not(:last-child) {
      border-right: 1px solid var(--xyo-line);
    }
  }

  .row3 {
    grid-template-columns: minmax(0, 1.45fr) minmax(250px, 1fr) minmax(220px, 0.8fr);
    margin-top: 0;

    > .card:not(:last-child) {
      border-right: 1px solid var(--xyo-line);
    }
  }

  .card {
    h3 {
      margin: 0 0 18px;
      color: var(--xyo-ink-strong);
      font-size: 15px;
      font-weight: 720;
    }

    h4 {
      color: var(--xyo-ink);
    }

    p,
    small {
      overflow-wrap: anywhere;
    }

    .kv {
      gap: 20px;
      margin-bottom: 11px;
      color: var(--xyo-ink);
      font-size: 13px;

      span {
        color: var(--xyo-muted);
      }

      b {
        min-width: 0;
        text-align: right;
        overflow-wrap: anywhere;
      }
    }

    .edit {
      margin-top: 12px;
      border-color: var(--xyo-line-strong);
      color: var(--xyo-primary);
      background: var(--xyo-accent-pale);
    }

    .quota-list {
      margin-bottom: 16px;
    }

    .quota {
      margin-bottom: 14px;

      .quota-head {
        margin-bottom: 7px;
      }

      label,
      .quota-head small,
      .quota-num,
      .quota-cycle {
        color: var(--xyo-muted);
      }

      .quota-num {
        font-variant-numeric: tabular-nums;
      }
    }

    .order-list {
      margin-top: 18px;
      padding-top: 16px;
      border-top: 1px solid var(--xyo-line);

      .order-item {
        gap: 12px;
        padding: 9px 0;
        border-bottom: 1px solid #e8e3ed;

        &:last-child {
          border-bottom: 0;
        }

        .o-amount {
          color: var(--xyo-ink-strong);
          font-variant-numeric: tabular-nums;
        }

        .o-status {
          color: var(--xyo-muted);
          background: var(--xyo-surface-muted);

          &.paid {
            color: var(--xyo-success);
            background: var(--xyo-success-soft);
          }

          &.pending {
            color: var(--xyo-warning);
            background: var(--xyo-warning-soft);
          }

          &.cancelling {
            color: var(--xyo-info);
            background: var(--xyo-info-soft);
          }

          &.cancelled {
            color: var(--xyo-muted);
            background: var(--xyo-surface-muted);
          }

          &.closed {
            color: var(--xyo-danger);
            background: var(--xyo-danger-soft);
          }
        }
      }
    }

    .invite-code {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 12px;
      padding: 12px 14px;
      border: 1px solid var(--xyo-line);
      border-radius: var(--xyo-radius-sm);
      color: var(--xyo-primary);
      background: var(--xyo-surface-muted);
      font-size: 17px;
      font-variant-numeric: tabular-nums;
    }

    .wx-name {
      color: var(--xyo-ink);
    }

    .wx-date {
      color: var(--xyo-muted);
      line-height: 1.65;
    }

    .mini-stats {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-template-rows: repeat(2, minmax(86px, 1fr));
      gap: 10px;
      margin-bottom: 0;

      div {
        display: flex;
        min-width: 0;
        flex-direction: column;
        justify-content: center;
        padding: 18px;
        border-left: 2px solid #e6a37e;
        border-radius: var(--xyo-radius-sm);
        text-align: left;
        background: var(--xyo-surface-muted);

        b {
          overflow: hidden;
          color: var(--xyo-ink-strong);
          font-size: 26px;
          line-height: 1.2;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        small {
          margin-top: 7px;
          color: var(--xyo-muted);
          font-size: 12px;
        }
      }
    }

    .chart,
    .invite-heart,
    .chart-decoration {
      display: none;
    }

    .sec-item,
    .act {
      min-height: 46px;
      padding: 5px 0;
      border-bottom-color: var(--xyo-line);
      color: var(--xyo-ink);

      &:hover {
        color: var(--xyo-primary);
      }

      i {
        display: grid;
        width: 36px;
        height: 36px;
        place-items: center;
        color: var(--xyo-muted);
      }

      &.danger span {
        color: var(--xyo-danger);
      }
    }
  }

  .usage-card {
    display: flex;
    flex-direction: column;

    .mini-stats {
      flex: 1;
    }
  }

  .share-center {
    .card-head a {
      color: var(--xyo-primary);
      font-weight: 700;
    }

    .share-item,
    .imp-item,
    .grant-item {
      gap: 12px;
      min-width: 0;
      padding: 12px 0;
      border-bottom-color: var(--xyo-line);

      > div,
      .si-main {
        min-width: 0;
      }

      p,
      small {
        color: var(--xyo-muted);
        line-height: 1.55;
      }
    }

    .imp-state,
    .grant-tags span {
      flex: 0 0 auto;
      color: var(--xyo-muted);
      background: var(--xyo-surface-muted);

      &.on {
        color: var(--xyo-success);
        background: var(--xyo-success-soft);
      }

      &.takeover {
        color: var(--xyo-warning);
        background: var(--xyo-warning-soft);
      }
    }

    .grant-tags .revoke {
      border-color: #ddb5ae;
      color: var(--xyo-danger);
      background: var(--xyo-danger-soft);
    }

    .empty-tip {
      color: var(--xyo-muted);
    }
  }

  ::v-deep .el-progress-bar__outer {
    background: var(--xyo-canvas-deep);
  }

  ::v-deep .el-progress-bar__inner {
    background: var(--xyo-primary) !important;
  }
}

.code-row {
  min-width: 0;

  .el-input {
    min-width: 0;
  }
}

@media (max-width: 1100px) {
  .profile-page {
    .row2,
    .share-center,
    .row3 {
      grid-template-columns: minmax(0, 1fr);

      > .card,
      > .card:nth-child(odd),
      > .card:not(:last-child) {
        border-right: 0;
        border-bottom: 1px solid var(--xyo-line);
      }

      > .card:last-child {
        border-bottom: 0;
      }
    }
  }
}

@media (max-width: 720px) {
  .profile-page {
    overflow-x: hidden;

    .banner {
      grid-template-columns: minmax(0, 1fr);
      align-items: start;
      gap: 20px;
      margin-bottom: 28px;
      padding: 2px 0 22px;

      .name-row {
        align-items: flex-start;
        flex-wrap: wrap;

        h2 {
          font-size: 26px;
        }
      }

      .meta {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 5px;
      }

      .side {
        grid-template-columns: auto 1fr;
        grid-template-areas:
          "action status"
          "intimacy intimacy";
        justify-items: start;
        width: 100%;
        min-width: 0;

        .status {
          justify-self: start;
        }

        .intimacy {
          grid-template-columns: auto minmax(0, 1fr) auto;
        }
      }
    }

    .workspace-heading {
      align-items: flex-start;
      margin-inline: 0;

      h2 {
        font-size: 18px;
      }

      p {
        max-width: 46%;
        font-size: 11px;
      }
    }

    .row2,
    .share-center,
    .row3 {
      margin-bottom: 28px;
      border-radius: var(--xyo-radius-md);

      > .card {
        padding: 20px;
      }
    }

    .card {
      .mini-stats {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }

      .order-list .order-item {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;

        .o-status {
          grid-column: 2;
        }
      }
    }

    .share-center {
      .share-item,
      .imp-item,
      .grant-item {
        align-items: flex-start;
        flex-wrap: wrap;
      }

      .grant-tags {
        flex-wrap: wrap;
      }
    }
  }

  .form-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
  }

  .code-row {
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }

  ::v-deep .yw-dialog {
    width: calc(100vw - 32px) !important;
    max-width: 420px;
    margin-top: 8vh !important;
  }
}

@media (max-width: 420px) {
  .profile-page .card .mini-stats {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .profile-page .card {
    transition: none;
  }
}
</style>
